import React from "react";
import DialogModal from "../../reusables/DialogModal";

const SuspendCompanyDialog = ({ isOpen, onClose, onConfirm, isSuspended }) => {
  return (
    <DialogModal isOpen={isOpen} onClose={onClose} title={`${isSuspended ? 'Activate' : 'Suspend'} Company`}>
      <p className="text-sm text-gray-500">
        Are you sure you want to {isSuspended ? 'activate' : 'suspend'} this company?<br />
        This will change the company’s current status.
      </p>
      <div className="mt-6 flex justify-between gap-3">
        <button
          className="px-4 py-2 bg-gray-300 rounded"
          onClick={onClose}
        >
          Cancel
        </button>
        <button
          className={`px-4 py-2 text-white rounded ${isSuspended ? 'bg-green-600' : 'bg-yellow-600'}`}
          onClick={onConfirm}
        >
          Confirm
        </button>
      </div>
    </DialogModal>
  );
};

export default SuspendCompanyDialog;